import { render, staticRenderFns } from "./businessAreaDetail.vue?vue&type=template&id=0c5eef7d&scoped=true&"
import script from "./businessAreaDetail.vue?vue&type=script&lang=js&"
export * from "./businessAreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./businessAreaDetail.vue?vue&type=style&index=0&id=0c5eef7d&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5eef7d",
  null
  
)

export default component.exports